import React from 'react'

import { useTranslation } from 'language/translator'

import Box from 'components_new/atoms/Box'

import DataStatus from 'components_new/organisms/DataStatus'

export interface TitleProps {
  live?: boolean
  segment?: string | number | null
}

const Title = (props: TitleProps) => {
  const { live, segment } = props

  const { t } = useTranslation()

  return (
    <>
      <Box
        component="span"
        sx={{
          color: segment ? 'text.secondary' : undefined,
          fontWeight: segment ? 'medium' : undefined
        }}
      >
        {t('global', 'explore')}
      </Box>
      {segment ? (
        <>
          <Box component="span" sx={{ color: 'text.disabled' }}>
            {'/'}
          </Box>
          <Box component="span">{segment}</Box>
        </>
      ) : null}
      {live ? <DataStatus variant="chip" /> : null}
    </>
  )
}

export default Title
